export const tipoabastecimento = {
  items: [
    { label: 's.configuracao.bico.automaticobico', value: 0 },
    { label: 's.relatorio.abastecimentocontingencia.abas', value: 1 },
    { label: 's.relatorio.abastecimentocontingencia.vtab', value: 2 },
    { label: 's.relatorio.abastecimentocontingencia.dppt', value: 3 },
    { label: 's.relatorio.abastecimentocontingencia.dkpd', value: 4 },
    { label: 's.relatorio.abastecimentocontingencia.dped', value: 5 },
  ],
};

export const colorSet = {
  0: '#008FFB', // Normal
  1: '#00E396', //
  2: '#FEB019',
  3: '#FF4560',
  4: '#775DD0',
  5: '#546E7A',
};

export const tipoVeiculo = {
  items: [
    { value: 0, label: 's.cadastro.veiculo.proprio' },
    { value: 1, label: 's.cadastro.veiculo.terceiros' },
  ],
};
